import { Button, Section, SectionHeader } from 'flos-react-cvi';
import React from 'react';
import { connect } from 'react-redux';
import { selectCurrentStep, selectPrimaryType, selectResources, selectUpdatingCoverage } from '../store/selectors';
import { completeCoverageSettings } from '../store/thunks';
import { AccidentCoverages } from './accident-coverages';
import { ContentsCoverages } from './contents-coverages';

const CoverageSettingsView = ({
    resources,
    isFocusOnThisSection,
    primaryType,
    completeCoverageSettingsProp,
    disableProceed
}) => {
    return (
        <Section variant={isFocusOnThisSection ? 'alt' : undefined}>
            <div className="container">
                <SectionHeader>{resources.coverageSectionHeading}</SectionHeader>
                <p>{resources.coverageSectionSubheading}</p>
                {primaryType === 'accident' ? <AccidentCoverages /> : <ContentsCoverages />}
                {isFocusOnThisSection && (
                    <div className="row">
                        <div className="col-md-8 col-xs-12 u-Space-up">
                            <Button
                                onClick={completeCoverageSettingsProp}
                                disabled={disableProceed}
                                variant="primary"
                                minWidth="wide"
                                data-testid="complete-coverage-settings-btn"
                            >
                                {resources.coverageSectionButtonText}
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        </Section>
    );
};

const mapStates = state => {
    return {
        resources: selectResources(state),
        isFocusOnThisSection: selectCurrentStep(state) === 1,
        primaryType: selectPrimaryType(state),
        disableProceed: selectUpdatingCoverage(state) !== null
    };
};

const mapDispatch = {
    completeCoverageSettingsProp: () => completeCoverageSettings()
};

export const CoverageSettings = connect(mapStates, mapDispatch)(CoverageSettingsView);
